module.exports = ".content h3 {\n  text-align: center;\n  padding-left: 0;\n  margin: 0; }\n\n.bold-section [class*=\"col-\"]:first-child {\n  font-weight: bold; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/components/publication-registration/step-summary-registration/step-summary-registration.component.scss
// module id = ./src/app/+app-custom/components/publication-registration/step-summary-registration/step-summary-registration.component.scss
// module chunks = main